import { render } from '@wordpress/element';
import FloatingButton from './components/FloatingButton';
import VoiceAgentButton from './components/VoiceAgentButton';
import './style.css';

window.addEventListener('load', function() {
    setTimeout(function() {
        // Check if shortcode is present
        if (document.querySelectorAll('.gc-ai-voice-agent-shortcode').length > 0) {
            document.body.setAttribute('data-has-voice-agent-shortcode', 'true');
        }

        // Handle floating button
        const floatingButtonContainer = document.getElementById('gc-ai-voice-agent-floating-button');
        if (floatingButtonContainer) {
            floatingButtonContainer.classList.add('gc-ai-voice-agent-root');

            render(
                <FloatingButton
                    position={gcVoiceChat.settings.buttonPosition}
                    color={gcVoiceChat.settings.buttonColor}
                    title={gcVoiceChat.settings.widgetTitle}
                />,
                floatingButtonContainer
            );
        }

        // Handle regular shortcode
        const shortcodeContainers = document.querySelectorAll('.gc-ai-voice-agent-shortcode');
        if (shortcodeContainers.length > 0) {
            shortcodeContainers.forEach(container => {
                container.classList.add('gc-ai-voice-agent-root');
                container.setAttribute('data-shortcode', 'true');

                render(
                    <FloatingButton
                        position={gcVoiceChat.settings.buttonPosition}
                        color={gcVoiceChat.settings.buttonColor}
                        title={gcVoiceChat.settings.widgetTitle}
                    />,
                    container
                );
            });
        }

        // Handle new button shortcode containers
        const buttonContainers = document.querySelectorAll('#gc-ai-voice-agent-button-container');
        if (buttonContainers.length > 0) {
            buttonContainers.forEach(container => {
                container.classList.add('gc-ai-voice-agent-root');

                // Get custom attributes from the container
                const customClass = container.getAttribute('data-custom-class') || '';
                const customStyle = container.getAttribute('data-custom-style') || '';

                render(
                    <VoiceAgentButton
                        customClass={customClass}
                        customStyle={customStyle}
                    />,
                    container
                );
            });
        }
    }, 300);
});